import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 8.04851C16 3.60309 12.4186 0 8 0C3.58137 0 0 3.60309 0 8.04851C0 12.0662 2.92384 15.3958 6.75069 16V10.3771H4.7211V8.04851H6.75069V6.27563C6.75069 4.2602 7.94301 3.14443 9.77096 3.14443C10.6477 3.14443 11.5638 3.3032 11.5638 3.3032V5.28335H10.5556C9.56055 5.28335 9.2537 5.90518 9.2537 6.54024V8.04851H11.4718L11.1167 10.3771H9.2537V16C13.0762 15.3958 16 12.0662 16 8.04851Z",
		fill: "#1877F2"
	})]
});
export default SvgFacebook;
